import { IncentivePayWindow } from '../incentive/incentive-pay-window.enum';

export enum PaySchedule {
  TBD = 0,
  Weekly = 1,
  MonthlyLastWeek = 2,
  //CurrentMonth = 2
  MonthlyFirstCoveringMonthEnd = 11,
  MonthlyFirstCoveringMonthEndFriClosed = 12
}

export const PayScheduleMapping: Record<PaySchedule, string> = {
  [PaySchedule.TBD]: 'TBD',
  [PaySchedule.Weekly]: 'Weekly',
  [PaySchedule.MonthlyLastWeek]: 'Monthly (Last Week)',
  //[IncentivePaySchedule.CurrentMonth]: 'Current Month (Last Full Pay Period)'
  [PaySchedule.MonthlyFirstCoveringMonthEnd]: 'Monthly (Close, Friday EOM is Open)',
  [PaySchedule.MonthlyFirstCoveringMonthEndFriClosed]: 'Monthly (Close)'
};

export const WindowsMapping: Record<PaySchedule, IncentivePayWindow[]> = {
  [PaySchedule.TBD]: [IncentivePayWindow.TBD],
  [PaySchedule.Weekly]: [IncentivePayWindow.TBD, IncentivePayWindow.Week],
  [PaySchedule.MonthlyLastWeek]: [IncentivePayWindow.TBD, IncentivePayWindow.MonthCurrent],
  [PaySchedule.MonthlyFirstCoveringMonthEnd]: [IncentivePayWindow.TBD, IncentivePayWindow.MonthPrior],
  [PaySchedule.MonthlyFirstCoveringMonthEndFriClosed]: [IncentivePayWindow.TBD, IncentivePayWindow.MonthPrior]
};
